import React from 'react';
import { useSelector } from 'react-redux';
import type { SrpState } from '../../reducers';

import { H1, H1Bold, H1Minor, SeoHeading } from './index.style';

const SeoH1 = () => {
    const {
        resultsPage: { query, adsTitle },
    } = useSelector((data: SrpState) => data);

    const hasSearchKeyword = query.length > 0;

    if (hasSearchKeyword && adsTitle.categorySeoDisplayName) {
        return (
            <H1>
                {adsTitle.totalNumberOfAdsFound} ads for <H1Bold>{query}</H1Bold>{' '}
                <H1Minor>in</H1Minor> {adsTitle.categorySeoDisplayName}
            </H1>
        );
    } else {
        return <SeoHeading>{adsTitle.plainText}</SeoHeading>;
    }
};

export default SeoH1;
